export default __webpack_public_path__ + "static/f1car-12b05e9ae1485d0206fac777c58ca16f.jpg";